'use client'

import { annualProgramHighlightMessage } from '../_utils/patient-form.domain'

import type { AnnualProgramPriceHighlight } from '@/app/[locale]/order/_utils/price-calculation.utils'


type APatientInfoAnnualProgramHighlightProps = {
	highlight: AnnualProgramPriceHighlight
}

export function APatientInfoAnnualProgramHighlight({
	highlight
}: APatientInfoAnnualProgramHighlightProps) {
	return (
		<div className='mb-6 whitespace-pre-line rounded-xl bg-medante-pink-secondary p-4 text-sm text-white'>
			{annualProgramHighlightMessage(highlight)}
		</div>
	)
}
